const sherlockImg = `${ASSETS_URL}/images/sherlock.svg`;

import Image from "next/image";
import { FlexColumn, FlexRowAlignCenter } from "@/components/Flex";
import { ASSETS_URL } from "@/config/deployConstants";
import br from "@/styles/breakpoints.module.css";

export const EmptyState = () => {
    return (
        <FlexRowAlignCenter
            as="section"
            style={{ gap: "5rem", maxWidth: "90rem", margin: "auto" }}
            className={br.mdDownColumn}>
            <Image
                quality={90}
                alt="no content"
                src={sherlockImg}
                width={280}
                height={280}
                style={{ objectFit: "contain" }}
            />
            <FlexColumn style={{ gap: "2rem" }} className={br.mdDownTextAlignCenter}>
                <h2
                    style={{ fontSize: "2.2rem", fontWeight: 600 }}
                    data-testid="auto-id-51c88acc-8e44-4de2-9454-eeb0607ba849">
                    {"Sorry we couldn't find anything for that search"}
                </h2>
                <p style={{ fontSize: "1.6rem" }} data-testid="auto-id-f6aa0dea-ae59-4ca4-9b8a-8e763157d1d7">
                    {
                        "Your search might have been too specific? Try broadening your search to see if that gives you the results you were looking for"
                    }
                </p>
            </FlexColumn>
        </FlexRowAlignCenter>
    );
};
